import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import styled from "styled-components"

const Anchor = styled.a`
    margin: 20px;
`

const Container = styled.div`
    border: 2px solid #eee;
    width: 300px;
    height: 180px;
    border-radius: 10px;
    padding: 10px;
    background-size: cover;
    background-image: url(${props => props.image});
    background-position: center;
    transition: transform 0.4s;

    &:hover {
        transform: scale(1.1);
    }
`

const Title = styled.h3`
    text-align: center;
    text-shadow: #ffffff91 0px 0px 5px;
    margin-top: 25px;
`

const Description = styled.p`
    text-shadow: #ffffff91 0px 0px 5px;
    color: #0080e2;
`

const StuffTile = ({ entry}) => (
    <Anchor href={entry.url}>
        <Container image={entry.image}>
            <Title>{entry.title}</Title>
            <Description>{entry.description}</Description>
        </Container>
    </Anchor>
)

StuffTile.propTypes = {
    entry: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
    }).isRequired
}

export default StuffTile


// WEBPACK FOOTER //
// ./src/components/stuffTile.js